const styles = () => ({
  searchIcon: {
    flexShrink: 0,
    marginLeft: 10,
  },

  clearFilterIcon: {
    cursor: 'pointer',
    marginRight: 8,
  },
});

export default styles;
